import { render, staticRenderFns } from "./AdminSection.vue?vue&type=template&id=f46aee62"
import script from "./AdminSection.vue?vue&type=script&lang=js"
export * from "./AdminSection.vue?vue&type=script&lang=js"
import style0 from "./AdminSection.vue?vue&type=style&index=0&id=f46aee62&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports